import { FingerprintProvider } from '@fingerprint/react';
import { NuqsAdapter } from 'nuqs/adapters/react';
import type { ReactNode } from 'react';
import { env } from '../config';
import { MantineProvider } from './MantineProvider';
import { ModalsProvider } from './ModalsProvider';
import { NotificationsProvider } from './NotificationsProvider';
import { QueryProvider } from './QueryProvider';

export const Providers = ({ children }: { children: ReactNode }) => {
  return (
    <FingerprintProvider
      apiKey={env.VITE_FINGERPRINT_API_KEY}
      endpoints={[env.VITE_FINGERPRINT_PROXY]}
      region={env.VITE_FINGERPRINT_REGION}
    >
      <NuqsAdapter>
        <QueryProvider>
          <MantineProvider>
            <ModalsProvider>
              <NotificationsProvider>{children}</NotificationsProvider>
            </ModalsProvider>
          </MantineProvider>
        </QueryProvider>
      </NuqsAdapter>
    </FingerprintProvider>
  );
};
